import React from 'react'
import './all-uploads-modal.styles.scss';
import Modal from '../modal/modal.component'
import EvidenceButton from '@/components/evidence-button/evidence-button.component';

const AllUploadsModal = ({
    show,
    cancel,
    progress
}) => {
    return (
        <div className='all-uploads-modal'>
            <Modal 
                show={show} 
                cancel={cancel} 
                text='View Uploads' 
                closeButton={true}  >
                <div className='all-uploads-content'>
                {
                    (progress && progress.uploads) &&
                    Object.values(progress.uploads).sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                    .map(u => (
                        <div key={u.timestamp} className='upload-item'>
                            <EvidenceButton evidenceData={u} />
                        </div>
                    ))
                }
                </div>
            </Modal>
        </div>
    )
}

export default AllUploadsModal